import { isVideoStation } from '../../../core/stations/helpers';
import { Fragment } from '../types';
import { useStation } from '../../../core/stations/hooks/useStation';

export function useIsVideoFragment(fragment: Fragment) {
  return isVideoStation(useStation(fragment.stationId));
}
